import axios from "axios";
import Cookies from 'js-cookie';
import axiosInstance from "./AxiosInstant";
const token = Cookies.get('authToken');
// const headers = {
//     Authorization: token ? `Bearer ${token}` :"",
// }


const url = "https:" + window.process.env.API_HOST_GLOBAL;
const videoApi = window.process.env.VIDEO_API;
const urlVideo = videoApi ? videoApi : url
export const PostData = async (path, data) => {
    return await axiosInstance().post(`${url}${path}`, data);
};
export const GetData = async (path) => {
    return await axiosInstance().get(`${url}${path}`);
};
export const GetDataPermissions = async (path,token) => {
    return await axiosInstance().get(`${urlVideo}${path}`);
}
export const DeleteData = async (path) => {
    return await axiosInstance().delete(`${url}${path}`);
};
export const UpdateData = async (path, data) => {
    return await axiosInstance().put(`${url}${path}`, data);
};
export const upload = async (path, data) => {
    return await axiosInstance().post(`${url}${path}`, data);
};

//send access stat
export const SendAccess = async (path, sessionId, action) => {
  try {
    return await axiosInstance().post(`${url}${path}`, {
      session_id: sessionId,
      action: action,
    });
  } catch (e) {
    console.error("ERROR Send access :", e);
  }
};

